export default __webpack_public_path__ + "ad29e50e8e9c1510f13404306ad7d690.svg";